module.exports = __webpack_public_path__ + "static/media/p4_s3.314bc188.ogg";